import React from 'react'

import { Link } from 'gatsby'

import BasketDropdown from '@components/Woocommerce/BasketDropdown'

import { CustomerContext } from '@context/customerContext'
import { WoocommerceContext } from '@context/woocommerceContext'

import { CustomizableComponent } from '@contracts/components/customizableComponent'

import * as styles from './AccountNav.module.scss'

import Basket from '@icons/basket.svg'
import Login from '@icons/login.svg'

interface Props extends CustomizableComponent {
	menuToggle: () => void
	isMenuOpen: boolean
	hideMenu: boolean
}

const AccountNav: React.FC<Props> = (props) => {
	const [cart] = React.useContext(WoocommerceContext).cart
	const [cartLoading] = React.useContext(WoocommerceContext).cartLoading
	const [justAdded] = React.useContext(WoocommerceContext).justAddedToCart

	const [user] = React.useContext(CustomerContext)

	const basketDropdownRef = React.useRef<HTMLLIElement>(null)
	const [basketActive, setBasketActive] = React.useState<boolean>(false)
	const [itemCount, setItemCount] = React.useState<boolean | number>(false)

	const accountNavClasses = [styles.nav]
	const hamburgerClasses = [styles.hamburger]
	const basketStyles = [styles.basketItem]

	if (props.className) {
		accountNavClasses.push(props.className)
	}

	if (props.isMenuOpen) {
		hamburgerClasses.push(styles.active)
	}

	if (props.hideMenu) {
		hamburgerClasses.push(styles.hide)
	}

	if (cartLoading) {
		basketStyles.push(styles.loading)
	}

	// Hover event for basket dropdown
	React.useEffect(() => {
		const basketDropdown = basketDropdownRef.current

		if (basketDropdown) {
			basketDropdown.addEventListener('mouseenter', () => {
				setBasketActive(true)
			})

			basketDropdown.addEventListener('mouseleave', () => {
				setBasketActive(false)
			})
		}
	}, [])

	React.useEffect(() => {
		if (cart) {
			setItemCount(cart.contents.itemCount)
		}
	}, [cart])

	React.useEffect(() => {
		if (justAdded) {
			setBasketActive(true)
		}
	})

	return (
		<menu className={accountNavClasses.join(' ')}>
			{!props.hideMenu ? (
				<li className={[styles.item, styles.hamburgerItem].join(' ')}>
					<div className={hamburgerClasses.join(' ')} onClick={() => props.menuToggle()}></div>
				</li>
			) : (
				<li className={[styles.item, styles.loginItem].join(' ')}>
					<Login />

					<Link to="/my-account" title="My Account">
						{user ? user.firstName : 'Login'}
					</Link>
				</li>
			)}

			<li className={[styles.item, ...basketStyles].join(' ')} ref={basketDropdownRef}>
				<Link to="/basket" title="Basket">
					<Basket />

					<span>{cart?.contents.itemCount || 0}</span>
				</Link>

				<div className={styles.dropdownWrapper}>
					<BasketDropdown active={basketActive} setActive={setBasketActive} />
				</div>
			</li>
		</menu>
	)
}

export default AccountNav
